export const onlyTextInputValidator = '^[a-zA-Z.,][a-zA-Z0-9.,-s ]*$';
export const onlyNumberInputValidator = '^[0-9]+$';
// export const domainNameValidator = '/^https?:\/\/(www\.)?(\w+)(\.\w.*)|(\w+.\w+.\w+)$/';
export const domainNameValidator = '^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$';
// export const domainNameValidator = '((?:(?:http?|ftp)[s]*:\\/\\/)?[a-z0-9-%\\/\\&=?\\.]+\\.[a-z]{2,4}\\/?([^\\s<>\\#%"\\,\\{\\}\\\\|\\\\\\^\\[\\]`]+)?)';
export const phoneNumberValidator = '(255|0)([0-9]{9})$';
export const phoneNumberValidatorWithPrefix = '[^0123459][0-9]{8}';
export const emailValidator = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
export const ipAddressValidator =
  '/^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$/';
export const tinNumberValidator = /^\\d{3}-\\d{3}-\\d{3}$/;
/// TODO domainNameValidator re-test pending
export const passwordValidator = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/;